export enum NOTIFICATION_TYPE {
  COMPLETE_SUBJECT_SELECTION = "complete_subject_selection",
  ELECTIVE_COMPLETION_CERTIFICATE_AVAILABLE = "elective_completion_certificate_available",
  COURSE_COMPLETION_CERTIFICATE_AVAILABLE = "course_completion_certificate_available",
  GRADE_COMPLETION_CERTIFICATE_AVAILABLE = "grade_completion_certificate_available",
  TERM_COMPLETION_CERTIFICATE_AVAILABLE = "term_completion_certificate_available",
  ASSIGNMENT_COMPLETION_CERTIFICATE_AVAILABLE = "assignment_completion_certificate_available",
  ASSIGNMENT_FEEDBACK_AVAILABLE = "assignment_feedback_available",
  ELECTIVES_NOT_SELECTED = "electives_not_selected",
  NEW_TERM_AVAILABLE = "new_term_available",
  NEW_SUBJECT_SELECTION_AVAILABLE = "new_subject_selection_available",
  NEW_ELECTIVES_AVAILABLE = "new_electives_available",
  NEW_PLP_SUBJECT_AVAILABLE = "new_plp_subject_available",
  GRADUATION_CERTIFICATE_AVAILABLE = "graduation_certificate_available",
  UNIVERSITY_PREPARATION_CERTIFICATE_AVAILABLE = "university_preparation_certificate_available"
}
